import { useContext } from 'react';
import type { IServiceOrganizationSettingContext } from '@frontend/components/pages/organizations/serviceSettings/serviceOrganizationSetting/ServiceOrganizationSettingsContext';
import { ServiceOrganizationSettingContext } from '@frontend/components/pages/organizations/serviceSettings/serviceOrganizationSetting/ServiceOrganizationSettingsContext';

export function useServiceOrganizationSettingContext(): IServiceOrganizationSettingContext {
    const serviceOrganizationSetting = useContext(ServiceOrganizationSettingContext);

    if (!serviceOrganizationSetting) {
        throw new Error('Expected to find context for serviceOrganizationSetting');
    }

    return serviceOrganizationSetting;
}
